import { AppContext } from "@lightspeed-invoicing/core-client/frontend"
import React, { useState } from "react"
import { Col, Row } from "react-bootstrap"
import { FormattedMessage, injectIntl } from "react-intl"
import ConnectIntegrationButton from "../../../common/button/connectintegrationbutton.component.jsx"
import { Intl } from "../../../state/helpers/IntlProps"
import { INTEGRATION_KEY } from "../../../state/integration/Constants"
import { ConfigurationZendeskSupport } from "../../../state/integration/IntegrationConfiguration"
import IntegrationConfigurationValue, { IntegrationConfigurationValueDto } from "../../../state/integration/IntegrationConfigurationValue"
import { renderConfigurationLabel } from "../../../utils/integration/pipedrive/index"
import ConfigurationValueComponent from "../ConfigurationValueComponent"

type OwnProps = {
    integrationConfigurationId: string,
    configuration: ConfigurationZendeskSupport,
    configurationValues: Array<IntegrationConfigurationValueDto>,
    onConfigurationChange: (configuration: ConfigurationZendeskSupport) => void,
    intl: Intl,
}

const ZendeskSupportFormComponent = (props: OwnProps) => {
    const [subdomain,setSubdomain]=useState("")
    const [errors, setErrors] = useState("")

    const validateSubdomain = (subdomain) => {
        const regex = /^[a-z0-9](?:[a-z0-9\-]{0,61}[a-z0-9])?$/
        if (!regex.test(subdomain)) {
            setErrors("Subdomain must begin and end with a lowercase alpha-numeric (i.e. letters [a-z] or digits [0-9]).")
        }
        if (subdomain.length > 63) {
            setErrors("Subdomain must have a length no greater than 63")
        }
        if (regex.test(subdomain) && subdomain.length <= 63) {
            setErrors("")
        }
    }

    if (!props.integrationConfigurationId) {

        const url = AppContext.getOptions().apiUrl
        + `/openid/connect/${INTEGRATION_KEY.ZENDESK_SUPPORT}/${AppContext.getUserLoggedIn().id}?subdomain=${subdomain}`

        return <Col className="ui-module">
            <Row className="form-group">
                <label className="col-3 col-form-label text-align-right">
                    <FormattedMessage
                        id="integration.form.edit.zendesk_support_connect"
                        defaultMessage="Enter zendesk subdomain"
                    />
                </label>
                <Col sm={9}>
                    <input
                        name="zendesk_subdomain"
                        value={subdomain}
                        onChange={(event) => {
                            const target = event.target
                            const value = target.value
                            setSubdomain(value)
                        }}
                        onBlur={() => {
                            validateSubdomain(subdomain)
                        }}
                        id="zendesk_subdomain"
                        type="text"
                        className="form-control"
                    />
                    <small><div className="text-danger">{errors}</div></small>
                </Col>
            </Row>
            <Row className="form-group">
                <Col sm={3}></Col>
                <Col sm={9}>
                    <ConnectIntegrationButton 
                        integrationKey={INTEGRATION_KEY.ZENDESK_SUPPORT} 
                        url={url}
                        disabled={subdomain === "" || errors !== ""}
                    />
                </Col>
            </Row>
        </Col>
    }

    return <Col className="ui-module">
        <Row className="form-group">
            <label className="col-3 col-form-label text-align-right" htmlFor="accountId">
                <FormattedMessage
                    id="integration.form.edit.zendesk.account_id"
                    defaultMessage="Subdomain"
                />
            </label>
            <Col sm={9}>
                <input
                    name="accountId"
                    value={props.configuration.accountId}
                    disabled={true}
                    id="accountId"
                    type="text"
                    className="form-control"
                />
            </Col>
        </Row>

        {props.configurationValues.map(v => {
            const cv = new IntegrationConfigurationValue(v)
            return (
                <ConfigurationValueComponent
                    key={cv.getId()}
                    configurationValue={cv}
                    value={props.configuration[cv.getKey()]}
                    onChange={value => {
                        props.configuration[cv.getKey()] = value
                        props.onConfigurationChange(props.configuration)
                    }}
                    renderConfigurationValueLabel={renderConfigurationLabel}
                    intl={props.intl}
                />
            )
        })}
    </Col>
}

export default injectIntl(ZendeskSupportFormComponent)


// WEBPACK FOOTER //
// ./src/integration/form/zendesk-support/ZendeskSupportFormComponent.tsx